import { createMemoStyles } from '@wds/styles';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { pricingElevation } from '~app/styles/theme';
import { BETWEEN_LG_XL_MEDIA_QUERY, BETWEEN_MD_LG_MEDIA_QUERY, LG_MEDIA_QUERY } from '~shared/media-query';

export default createMemoStyles(({ spacing, type, pricingPalette }: PricingAppTheme) => ({
  Shadow: {
    boxShadow: `0px 2px 8px 0px rgba(0, 0, 0, 0.16)`,
  },
  Switch: {
    fontSize: type.fontSize.body,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    margin: [0, 'auto'],
    lineHeight: 1.5,
    color: pricingPalette.colors.slate,
    backgroundColor: pricingPalette.colors.pebble,
    border: `1px solid ${pricingPalette.colors.flint}`,
    borderRadius: 50,
    minHeight: '36px',

    [LG_MEDIA_QUERY]: {
      marginBottom: 0,
    },

    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
    },
  },
  Values: {
    minHeight: 28,
    width: '100%',
    borderRadius: 50,
    display: 'flex',
    alignSelf: 'stretch',
    position: 'relative',
    cursor: 'pointer',

    [BETWEEN_MD_LG_MEDIA_QUERY]: {
      fontSize: '.75em',
    },
    [BETWEEN_LG_XL_MEDIA_QUERY]: {
      fontSize: '.75em',
    },

    '& span': {
      textAlign: 'center',
      zIndex: pricingElevation.plusOne,
      transition: 'all ease-out .3s',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 50,
      maxWidth: '50%',
      flexBasis: '50%',
      boxSizing: 'border-box',
    },
  },

  NotSelected: {
    backgroundColor: 'transparent',
    fontWeight: type.fontWeight.light,
    color: pricingPalette.colors.charcoal,
  },
  Selected: {
    fontWeight: type.fontWeight.medium,
    backgroundColor: pricingPalette.colors.white,
    border: `1px solid ${pricingPalette.colors.charcoal}`,
    color: pricingPalette.colors.charcoal,
    height: '100%',
  },
}));
